import { render } from "./AdminConcerts.vue?vue&type=template&id=779514aa&scoped=true"
import script from "./AdminConcerts.vue?vue&type=script&lang=js"
export * from "./AdminConcerts.vue?vue&type=script&lang=js"

import "./AdminConcerts.vue?vue&type=style&index=0&id=779514aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779514aa"]])

export default __exports__